import { useParams } from 'react-router-dom'

export const useWaveId = () => {
  const { waveId } = useParams()

  if (!waveId) {
    throw new Error('Missing wave ID required for route')
  }

  return waveId
}
